import React from 'react';
import BookingWidget from './BookingWidget';

interface BookingPageProps {
  language: string;
}

export const BookingPage: React.FC<BookingPageProps> = ({ language }) => {
  return (
    <main className="pt-32 pb-20 min-h-screen">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {language === 'en' ? 'Book a Table' : 'Reserve uma Mesa'}
          </h1>
          <p className="text-gray-600 max-w-2xl mx-auto">
            {language === 'en' 
              ? 'Experience the unique atmosphere of our garden restaurant. Reserve your table now for a memorable dining experience.' 
              : 'Experimente a atmosfera única do nosso restaurante jardim. Reserve sua mesa agora para uma experiência gastronômica memorável.'}
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="booking-image-container rounded-lg overflow-hidden shadow-lg">
            <img 
              src="/images/restaurant-interior.jpg" 
              alt={language === 'en' ? "Restaurant Interior" : "Interior do Restaurante"}
              className="w-full h-full object-cover"
            />
          </div>
          
          <div className="booking-widget-container">
            <BookingWidget language={language} />
          </div>
        </div>
        
        <div className="booking-info mt-16">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
              {language === 'en' ? 'Reservation Information' : 'Informações de Reserva'}
            </h2>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
              <div className="info-card p-6 rounded-lg bg-gray-50">
                <div className="icon-container mx-auto mb-4 w-16 h-16 rounded-full bg-[var(--color-pink)] bg-opacity-10 flex items-center justify-center">
                  <i className="far fa-clock text-[var(--color-pink)] text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold mb-2">
                  {language === 'en' ? 'Opening Hours' : 'Horário de Funcionamento'}
                </h3>
                <p className="text-gray-600">
                  {language === 'en' ? 'Open daily: 18:30 - 21:30' : 'Aberto diariamente: 18:30 - 21:30'}
                </p>
              </div>
              
              <div className="info-card p-6 rounded-lg bg-gray-50">
                <div className="icon-container mx-auto mb-4 w-16 h-16 rounded-full bg-[var(--color-pink)] bg-opacity-10 flex items-center justify-center">
                  <i className="fas fa-phone-alt text-[var(--color-pink)] text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold mb-2">
                  {language === 'en' ? 'Contact Us' : 'Contate-nos'}
                </h3>
                <p className="text-gray-600">+351 282 763 777</p>
              </div>
              
              <div className="info-card p-6 rounded-lg bg-gray-50">
                <div className="icon-container mx-auto mb-4 w-16 h-16 rounded-full bg-[var(--color-pink)] bg-opacity-10 flex items-center justify-center">
                  <i className="fas fa-map-marker-alt text-[var(--color-pink)] text-2xl"></i>
                </div>
                <h3 className="text-lg font-semibold mb-2">
                  {language === 'en' ? 'Our Location' : 'Nossa Localização'}
                </h3>
                <p className="text-gray-600">R. Lançarote de Freitas 46<br/>8600-632 Lagos</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default BookingPage; 